// Which quotes carry an objective QuoteMaker wrote (an AI quote generation or
// the deterministic Stage 5 draft). Their objective is a generated value the
// one resolver (resolveQuoteObjective in src/services/quote-objective.ts)
// conforms; any other stored quote objective is imported or legacy text of
// unknown authorship and is shown as written.
//
// There is no objective sync. Stage 4 and Stage 5 show one value, computed
// once by App (useQuoteObjective), so there is nothing to copy between them.

export function isGeneratedQuoteObjective(generatedBy: unknown): boolean {
    return generatedBy === 'ai-quote-generation'
        || generatedBy === 'deterministic-stage5-draft';
}
